<section class="panel">
  <div class="panel__group hidden__mobile">
    <app-button
      type="button"
      color="primary"
      icon="agres-file"
      (btnClick)="openTarefaDoTalhaoById()"
      title="{{ 'fields.title' | translate }}">
    </app-button>
    <app-button
      type="button"
      color="primary"
      icon="agres-app"
      (btnClick)="openSidebarMenuFieldFiles()"
      title="{{ titleButtonMenuFieldFile | translate }}">
      ></app-button
    >
    <app-button
      [disabled]="!showButton"
      type="button"
      color="info"
      icon="agres-field"
      (btnClick)="navigateToTaskListWithFieldName()"
      title="{{ 'fields.my-tasks' | translate }}">
    </app-button>
    <app-button
      type="button"
      color="primary"
      icon="agres-edit"
      (btnClick)="navigateToEditFieldPage()"
      title="{{ 'global.edit' | translate }}">
    </app-button>
    <app-button
      type="button"
      color="return"
      icon="agres-return"
      (btnClick)="goBack()"
      title="{{ 'global.back' | translate }}">
    </app-button>
  </div>
</section>
<div
  *ngIf="
    summarizedForecast.icon === '' &&
    summarizedForecast.precipChance === '' &&
    summarizedForecast.relativeHumidity === '' &&
    summarizedForecast.windSpeed === ''
  ">
  <p class="text-danger">*{{ 'tasks.tabs.weather.label-unavailable' | translate }}</p>
</div>
<section
  *ngIf="
    summarizedForecast.icon &&
    summarizedForecast.precipChance &&
    summarizedForecast.relativeHumidity &&
    summarizedForecast.windSpeed
  "
  class="weather">
  <div class="weather__content">
    <img src="../../../../../assets/images/weather/sun-light.png" alt="" />
    <div class="weather__content--text">
      <h1>{{ summarizedForecast.temperature }} {{ 'global.temperature-symbol' | translate }}</h1>
      <p>{{ 'global.temperature' | translate }}</p>
    </div>
  </div>
  <div class="weather__content">
    <img src="../../../../../assets/images/weather/heavy-rain-light.png" alt="" />
    <div class="weather__content--text">
      <h1>{{ summarizedForecast.precipChance }} {{ 'global.percentage' | translate }}</h1>
      <p>{{ 'global.rain' | translate }}</p>
    </div>
  </div>
  <div class="weather__content">
    <img src="../../../../../assets/images/weather/partial-cloudy-light.png" alt="" />
    <div class="weather__content--text">
      <h1>{{ summarizedForecast.relativeHumidity }} {{ 'global.percentage' | translate }}</h1>
      <p>{{ 'global.humidity' | translate }}</p>
    </div>
  </div>
  <div class="weather__content">
    <img src="../../../../../assets/images/weather/heavy-wind-light.png" alt="" />
    <div class="weather__content--text">
      <h1>{{ summarizedForecast.windSpeed }} {{ 'global.velocity-symbol' | translate }}</h1>
      <p>{{ 'global.velocity' | translate }}</p>
    </div>
  </div>
</section>
<section class="description">
  <div class="description__content">
    <p>
      {{ 'fields.name' | translate }}:
      <span>
        {{ talhaoById?.name }}
      </span>
    </p>
    <p>
      {{ 'global.area' | translate }}:
      <span>
        {{ talhaoById?.totalArea }}
      </span>
    </p>
    <p>
      {{ 'global.description' | translate }}:
      <span>
        {{ talhaoById?.description }}
      </span>
    </p>
  </div>
</section>

<div class="row">
  <div class="col-sm-12 col-md-3 col-lg-2">
    <!-- ADICIONAR SIDEBAR MENU PARA ARQUIVOS -->
    <section>
      <div *ngIf="apiData">
        <app-sidebar-menu-field-files
          [isMenuFieldFileOpen]="menuFieldFileStatus"
          [shpFiles]="shpFiles"
          [name]="talhaoById.name"
          [fieldName]="fieldId"
          [geometry]="geometry"
          (filesToShow)="showShapefiles($event)"></app-sidebar-menu-field-files>
      </div>
    </section>
    <!-- FINAL DO MENU MY FILES -->
  </div>

  <div class="col-{{ menuFieldFileStatus ? '10' : '12' }} colMapa">
    <section class="maps">
      <div *ngIf="apiData">
        <div class="maps__content">
          <app-mapa-talhao
            [polygonColor]="selectedColor"
            [mode]="'view'"
            [mapHeight]="heightMaps"
            [recommendationMapArray]="recommendationMapArray"
            [guidesArray]="guidesArray"
            [boundariesArray]="boundariesArray">
          </app-mapa-talhao>
        </div>
      </div>
    </section>
  </div>
</div>
<app-menu-pwa>
  <div class="pwa__list--info">
    <button type="button" (click)="dashboard()">
      <i class="agres-app"></i>
      <p>{{ 'sidebar.title-dashboard' | translate }}</p>
    </button>
  </div>
  <div class="pwa__list--info">
    <button type="button" (click)="openSidebarMenuFieldFiles()">
      <i class="agres-folder"></i>
      <p>{{ titleButtonMenuFieldFile | translate }}</p>
    </button>
  </div>
  <div class="pwa__list--info">
    <button type="button" (click)="openTarefaDoTalhaoById()">
      <i class="agres-file"></i>
      <p>{{ 'fields.title' | translate }}</p>
    </button>
  </div>
  <div class="pwa__list--info">
    <button type="button" (click)="navigateToEditFieldPage()">
      <i class="agres-field-edit"></i>
      <p>{{ 'global.edit' | translate }}</p>
    </button>
  </div>
  <div class="pwa__list--info">
    <button type="button" (click)="navigateToTaskListWithFieldName()" [disabled]="!showButton">
      <i class="agres-field-edit"></i>
      <p>{{ 'fields.my-tasks' | translate }}</p>
    </button>
  </div>
</app-menu-pwa>
